import { render, staticRenderFns } from "./rules-add-form.vue?vue&type=template&id=8fcb75a6&"
import script from "./rules-add-form.vue?vue&type=script&lang=js&"
export * from "./rules-add-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports